/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-cursor-2': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.087 7.537l-13.75-5a.625.625 0 00-.8.8l5 13.75a.625.625 0 001.17.02l2.4-6 6-2.4a.625.625 0 000-1.17h-.02zm-6.693 2.5l-.25.1-.1.25-1.919 4.738L4.169 4.169l10.956 3.956-4.731 1.912z"/>'
  }
})
